(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_d711999"] && !Shopify.designMode) return;
  try {
    function initCollectionDescriptionToggles() {
    document.querySelectorAll('[data-collection-description-content]').forEach(function (content) {
      var toggle = content.parentElement.querySelector('[data-collection-description-toggle]');

      if (!toggle || toggle.dataset.initialized === 'true') return;

      toggle.dataset.initialized = 'true';

      function updateToggleVisibility() {
        if (content.classList.contains('is-expanded')) return;

        toggle.hidden = content.scrollHeight <= content.clientHeight + 1;
      }

      updateToggleVisibility();

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateToggleVisibility).observe(content);
      }

      toggle.addEventListener('click', function () {
        var expanded = content.classList.toggle('is-expanded');
        var moreLabel = toggle.querySelector('[data-collection-description-more]');
        var lessLabel = toggle.querySelector('[data-collection-description-less]');

        toggle.setAttribute('aria-expanded', String(expanded));
        moreLabel.hidden = expanded;
        lessLabel.hidden = !expanded;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionDescriptionToggles);
  } else {
    initCollectionDescriptionToggles();
  }
  } catch(e) { console.error(e); }
})();

})();
